<section class="trb" aria-labelledby="trb-heading">
  <to-section-title
    headingId="trb-heading"
    [title]="'testRunNew.repo.title' | translate"
    [subtitle]="'testRunNew.repo.subtitle' | translate"
  ></to-section-title>

  @if (repositoriesError()) {
    <p class="trb__status trb__status--error" role="alert" data-testid="tln-repo-list-error">
      {{ 'testRunNew.repo.listError' | translate }}
    </p>
  } @else if (rows().length === 0) {
    <p class="trb__empty" data-testid="tln-repo-empty">{{ 'testRunNew.repo.empty' | translate }}</p>
  } @else {
    <h3 class="trb__label" id="trb-repos-label">{{ 'testRunNew.repo.listLabel' | translate }}</h3>
    <div class="trb__repos" role="group" aria-labelledby="trb-repos-label">
      @for (row of rows(); track row.id) {
        <button
          type="button"
          class="trb__repo"
          data-testid="tln-repo-row"
          [attr.data-repository-id]="row.id"
          [class.trb__repo--on]="selectedRepositoryId() === row.id"
          [attr.aria-pressed]="selectedRepositoryId() === row.id"
          [disabled]="disabled()"
          (click)="onRepository(row.id)"
        >
          <span class="trb__radio" aria-hidden="true"></span>
          <span class="trb__dot" [attr.data-provider]="row.provider" aria-hidden="true"></span>
          <span class="trb__repo-text">
            <span class="trb__repo-url">{{ row.shortUrl }}</span>
            <span class="trb__repo-provider">{{ row.providerKey ? (row.providerKey | translate) : row.provider }}</span>
          </span>
          @if (row.branch) {
            <code class="trb__branch" data-testid="tln-repo-branch">{{ row.branch }}</code>
          } @else {
            <span class="trb__branch trb__branch--none" data-testid="tln-repo-branch">
              {{ 'testRunNew.repo.branchUnknown' | translate }}
            </span>
          }
        </button>
      }
    </div>
    <p class="trb__hint">{{ 'testRunNew.repo.settingsHint' | translate }}</p>
  }

  @if (hasSelectedRepository()) {
    @if (pipelinesLoading()) {
      <p class="trb__status" data-testid="tln-pipeline-loading">{{ 'testRunNew.repo.loading' | translate }}</p>
    } @else if (pipelinesFailed()) {
      <p class="trb__status trb__status--error" role="alert" data-testid="tln-pipeline-error">
        {{ pipelineErrorKey() | translate }}
      </p>
    } @else if (pipelines().length === 0) {
      <p class="trb__status" data-testid="tln-pipeline-empty">{{ 'testRunNew.repo.pipelineEmpty' | translate }}</p>
    }
  }

  @if (showPipelines() && pipelines().length > 0) {
    <div class="trb__found">
      <span class="trb__badge" data-testid="tln-repo-connected">
        <mat-icon aria-hidden="true">check</mat-icon>
        {{ 'testRunNew.repo.connected' | translate }}
      </span>
      <span class="trb__found-text" data-testid="tln-repo-found">
        {{ foundKey() | translate: { count: pipelines().length, branch: readBranch() } }}
      </span>
    </div>

    <h3 class="trb__label trb__label--sr" id="trb-pipelines-label">
      {{ 'testRunNew.repo.pipelineListLabel' | translate }}
    </h3>
    <div class="trb__pipelines" role="group" aria-labelledby="trb-pipelines-label">
      @for (pipeline of pipelines(); track pipeline.file) {
        <div class="trb__pipeline-group">
          <button
            type="button"
            class="trb__pipeline"
            data-testid="tln-pipeline-row"
            [attr.data-pipeline-file]="pipeline.file"
            [attr.aria-pressed]="selectedPipelineFile() === pipeline.file"
            [disabled]="disabled()"
            (click)="onPipeline(pipeline.file)"
          >
            <span class="trb__radio" aria-hidden="true"></span>
            <code class="trb__pipeline-file">{{ pipeline.file }}</code>
            <span class="trb__pipeline-name">{{ pipeline.name }}</span>
            <span class="trb__pipeline-count">
              {{ stepCountKey(pipeline.steps.length) | translate: { count: pipeline.steps.length } }}
            </span>
          </button>

          @if (selectedPipelineFile() === pipeline.file) {
            <div
              class="trb__steps"
              data-testid="tln-pipeline-steps"
              [attr.aria-label]="'testRunNew.repo.stepsLabel' | translate: { name: pipeline.name }"
            >
              <p class="trb__steps-title">{{ 'testRunNew.repo.steps' | translate }}</p>
              <ol class="trb__step-list">
                @for (step of pipeline.steps; track $index) {
                  <li class="trb__step">
                    <span class="trb__step-index" aria-hidden="true">{{ $index + 1 }}</span>
                    <code class="trb__step-text">{{ step }}</code>
                  </li>
                }
              </ol>
            </div>
          }
        </div>
      }
    </div>
  }
</section>
